import http from '@/api/http';
import { serialize } from '@/utils/format';

export async function listProject(token, data) {

    // console.log(data);
    let query = "";
    let qq = "?"
    if (data.pic_h > 0) {
        query += "?pic_h=" + data.pic_h
        qq = "&"
    }
    if (data.pic_w > 0) {
        query += qq +"pic_w=" + data.pic_w
        qq = "&"
    }
    if (data.company_id > 0) {
        query += qq + "company_id=" + data.company_id
    }

    // console.log(query);

    try {

        // console.log(query);

        const response = await http.get('api/v1/project/list' + query,
            {
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
            })

        return response.data

    } catch (error) {
        console.log(error.response)
        return null
    }
}

export async function listUsers(token, id) {
    try {
        const response = await http.get('api/v1/user/project?id=' + id,
            {
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
            })

        return response.data

    } catch (error) {
        console.log(error.response)
        return null
    }    
}

export async function getProject(token, id, width) {
    try {
        const response = await http.get('api/v1/project?id=' + id,
            {
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
            })

        return response.data

    } catch (error) {
        console.log(error.response)
        return null
    }
}

export async function inviteCode(token, data) {
    try {
        let dataPram = {
            'id': data.id,
            'role': data.role,
        }

        const response = await http.get('api/v1/project/link-code?' + serialize(dataPram), {
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
        })

        return response.data

    } catch (error) {
        console.log(error.response)
        return null
    }
}

export async function updateProject(token, data) {
    try {
        let dataPram = {
            'name': data.name,
            'description': data.description,
            'budget': data.budget ? data.budget.budget_plan : data.budget_plan
        }
        if (data.id > 0) {
            dataPram['id'] = data.id
        }
        
        if (data.company_id) {
            dataPram['company_id'] = data.company_id
        }

        if (data.image) {
            dataPram['pic'] = data.image
        }
        
        if (data.date_planned_start) {
            dataPram['date_planned_start'] = data.date_planned_start
        }

        if (data.date_planned_end) {
            dataPram['date_planned_end'] = data.date_planned_end
        }

        console.log(dataPram);
        const response = await http.post('api/v1/project',
            dataPram,
            {
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data',
                }
            })

        return response.data

    } catch (error) {
        console.log(error.response)
        return null
    }
}

export async function archProject(token, id) {
    try {
        let dataPram = {
            'id': id
        }
        const response = await http.post('api/v2/archive/project', 
            dataPram,
            {
                headers: { 
                    'Authorization': 'Bearer ' + token, 
                    'Content-Type': 'multipart/form-data' 
                }
            })

        return response.data

    } catch (error) {
        console.log(error.response)
        return null
    }
}

export async function delProject(token, id) {
    try {
        const response = await http.delete('api/v1/project?id=' + id, {
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
        })

        return response.data

    } catch (error) {
        console.log(error.response)
        return null
    }
}

export async function listController(token, projectId) {
    try {
        let dataPram = {
            'id': projectId
        }
        const response = await http.get('api/v3/control/project?' + serialize(dataPram), {
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
        })
        return response.data
    } catch (error) {
        console.log(error.response)
        return null
    }
}

export async function assignController(token, data) {
    try {
        let dataPram = {
            'id': data.projectId,
            'user': data.userId
        }
        const response = await http.post('api/v3/control/project', 
            dataPram,
            {
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'multipart/form-data' }
            })
        return response.data
    } catch (error) {
        console.log(error.response)
        return null        
    }
}

export async function detachController(token, data) {
    try {
        let dataPram = {
            'id': data.projectId,
            'user': data.userId
        }
        const response = await http.get('api/v3/control/proj-delete?' + serialize(dataPram), {
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
        })
        return response.data
    } catch (error) {
        console.log(error.response)
        return null        
    }
}

export async function listManager(token, projectId) {
    try {
        let dataPram = {
            'id': projectId
        }
        const response = await http.get('api/v3/manager?' + serialize(dataPram), {
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
        })
        return response.data
    } catch (error) {
        console.log(error.response)
        return null
    }
}

export async function assignManager(token, data) {
    try {
        let dataPram = {
            'id': data.projectId,
            'user': data.userId
        }
        const response = await http.post('api/v3/manager',
            dataPram,
            {
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'multipart/form-data' }
            }
        )
        return response.data
    } catch (error) {
        console.log(error.response)
        return null        
    }
}

export async function detachManager(token, data) {
    try {
        let dataPram = {
            'id': data.projectId,
            'user': data.userId
        }
        const response = await http.get('api/v3/manager/delete?' + serialize(dataPram), {
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
        })
        return response.data
    } catch (error) {
        console.log(error.response)
        return null        
    }
}